import { FC, ReactElement, useMemo } from 'react';

import { CategorySliderInterface } from '../../entities/@blocks/CategorySlider/CategorySlider';
import { Device } from '../../entities/Device/Device';
import { generateUuid } from '../../helpers/string';
import { useDeviceWidth } from '../../hooks';
import { SliderSection } from '../index';
import { CategoryCard } from './subcomponents';

import './CategorySlider.scss';

export interface CategorySliderProps extends CategorySliderInterface {
    className?: string;
}

export const CategorySlider: FC<CategorySliderProps> = ({
    title,
    categories,
    className = '',
}): ReactElement => {
    const { isDesktop } = useDeviceWidth();

    const id = useMemo((): string => (
        `category-slider-${title || generateUuid()}`
    ), [title]);

    const columns = {
        [Device.mobile]: 3.25,
        [Device.tabletPortrait]: 5,
        [Device.tabletLandscape]: 8,
        [Device.desktop]: 9,
    };

    return (
        <SliderSection
            startAtCenter={isDesktop}
            id={id}
            title={title}
            items={categories.map(category => (
                <CategoryCard {...category} />
            ))}
            columns={columns}
            className={`category-slider ${className}`}
            sliderClassName="category-slider__slider"
        />
    );
};
